import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import Header from "../../components/Header";
import { getBlogDetails } from "selectors/blog";
import { fetchBlog, listBlogs } from "actions/blog";

import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import nophoto from "../../img/nophoto.jpg";

const BlogDetails = ({ blogDetails }) => {
  // const history = useHistory();
  const { blogData, isFetching, isFetched } = blogDetails;
  const { id, title, excerpt, publishedAt, cover, content } = blogData;

  const details = blogData.data.attributes;
  const { t } = useTranslation();
  return (
    <>
      <Header></Header>
      <div className="container mx-auto">
        <div className="mt-10">
          <div className="font-bold text-blue text-xl mb-10">
            {details.title}
          </div>
          <div>
            <img
              src={
                details.cover.data.attributes === null
                  ? nophoto
                  : details.cover.data.attributes.formats.small
                  ? `${process.env.RAZZLE_STRAPI_URL}${details.cover.data.attributes.formats.small.url}`
                  : `${process.env.RAZZLE_STRAPI_URL}${details.cover.data.attributes.formats.thumbnail.url}`
              }
            />
          </div>
          <div className="mt-10 mb-10 text-pink">
            {t("reported")} {moment(publishedAt).format("DD.MM.YYYY")}
          </div>
          <div className="mb-48 default-link-colors">
            <ReactMarkdown
              source={details.content}
              escapeHtml={false}
              transformImageUri={(link) => {
                return `${link}`;
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

BlogDetails.getInitialProps = async ({ store, match }) => {
  await fetchBlog(match.params.blogId)(store.dispatch);
};

const mapStateToProps = (state) => ({
  blogDetails: getBlogDetails(state),
});

export default connect(mapStateToProps, null)(BlogDetails);
